import { render, staticRenderFns } from "./AudioWidget.vue?vue&type=template&id=7a687378&"
import script from "./AudioWidget.vue?vue&type=script&lang=js&"
export * from "./AudioWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports